import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { PaginatorState } from 'src/app/shared/components/paginator/paginator.module';
import { GameListItem } from 'src/app/shared/interfaces/game.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { MiniGameService } from '../minigame.service';

@UntilDestroy()
@Component({
  selector: 'app-game-like-collection',
  templateUrl: './game-like-collection.component.html',
  styleUrls: ['./game-like-collection.component.scss'],
})
export class GameLikeCollectionComponent implements OnInit {
  constructor(
    private layout: LayoutService,
    private miniGameService: MiniGameService,
    private appService: AppService,
  ) {}

  games: GameListItem[] = [];
  loading: boolean = true;

  //分页器
  paginator: PaginatorState = {
    page: 1,
    pageSize: 24, // 每页24个
    total: 0,
  };

  ngOnInit() {
    this.getFavoriteList(true);
  }

  getFavoriteList(init: boolean) {
    this.loading = true;
    this.miniGameService.getFavoriteList(this.paginator.page, this.paginator.pageSize).subscribe(data => {
      if (data) {
        this.loading = false;
        this.paginator.total = data.total;
        if (data.gameList) {
          if (init) {
            this.games = data.gameList;
          } else {
            this.games.push(...data.gameList);
          }
        }
      }
    });
  }

  breakpoint = 0;
  initBreakpoint(on: boolean, el: HTMLDivElement) {
    if (!on) return;
    this.layout
      .getBreakpoint(el)
      .pipe(untilDestroyed(this))
      .subscribe(x => {
        this.breakpoint = x as number;
      });
  }

  updatedFavoriteIds = this.miniGameService.allFavoriteIds$.pipe(untilDestroyed(this)).subscribe(ids => {
    this.games.forEach(e => {
      e.isFavorite = ids.includes(e.id);
    });
  });
}
